import isEmpty from 'lodash/isEmpty';

export default {
  shrinkText(text, limit = 30) {
    if (isEmpty(text)) return '';

    return text.length > limit ? `${text.substring(0, limit - 3)}...` : text;
  },
  isUrl(str) {
    const pattern = new RegExp(
      '^(http(s)?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$',
      'i'
    );
    return !!pattern.test(str);
  },

  isValidUPI(str) {
    return /^\w.+@\w+$/.test(str);
  },
  getFileType(url) {
    return (
      url
        .split('.')
        .pop()
        // eslint-disable-next-line no-useless-escape
        .split(/\#|\?/)[0]
    );
  },
  isValidMobile(mobile) {
    return /^[5-9]\d{9}$/.test(mobile) && `${mobile}`.length === 10;
  },
  isValidOTP(otp) {
    return `${otp}`.length === 4;
  },
  isOnlyAlpha(name) {
    return /^[a-zA-Z ]*$/.test(name);
  },
  isWord(word) {
    return /^([a-zA-Z0-9 _-]+)$/.test(word);
  },
  isNum(num) {
    return /^[0-9]*$/.test(num);
  },
};
